import React, { useCallback, useState } from 'react'
import { useNewTranslation } from 'hooks/index'
import { theme } from 'theme'
import { Box, Text } from 'rebass'
import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { selectSelectedCampaignUuid } from 'state/review'
import { massApproveByUsername, selectRegistrationRemainingSlots } from 'state/registrations'
import { ActionType } from '.'
import ListApprovePopUp from 'components/Shared/ListApprovePopUp'
import { PLATFORM_ENUM } from 'services/api/constants'

interface RegistrationsListApprovalProps {
    close: () => void
    moveToStep: (step: number) => void
    maxRows?: number
    actionType: ActionType
}

const RegistrationsListApproval: React.FC<RegistrationsListApprovalProps> = ({ close, moveToStep, actionType }) => {
    const [remainSlotsInfo, setRemainSlotsInfo] = useState({ remainSlotsError: false, listUserTotalNum: 0 })
    const campaignUuid = useSelector(selectSelectedCampaignUuid)
    const interestRegistrationRemainingSlots = useSelector(selectRegistrationRemainingSlots)

    const dispatch = useDispatch()
    const [newT] = useNewTranslation()

    const onProceed = useCallback(
        ({ usernames, platform }: { usernames: string[]; platform: PLATFORM_ENUM }) => {
            if (usernames.length > 0) {
                moveToStep(2) // Go to loading
                if (campaignUuid) {
                    dispatch(
                        massApproveByUsername({ campaignUuid, usernames, platform, callback: moveToStep, actionType }),
                    )
                }
            }
        },
        [campaignUuid, dispatch, actionType],
    )
    const resetRemainSlotsInfo = (totalUserNum: number, isRemainSlosError: boolean) => {
        setRemainSlotsInfo({ ...remainSlotsInfo, remainSlotsError: isRemainSlosError, listUserTotalNum: totalUserNum })
    }
    return (
        <>
            <ListApprovePopUp
                onClickNextMove={onProceed}
                close={close}
                softLimitNumber={interestRegistrationRemainingSlots}
                softLimit={true}
                softLimitError={(totalUsername: number) =>
                    newT('errorMessage.validation.exceedMaximumAccount', {
                        count: interestRegistrationRemainingSlots && totalUsername - interestRegistrationRemainingSlots,
                    })
                }
                setTotal={resetRemainSlotsInfo}
            >
                <Box my={theme.spacing.xxs}>
                    <Box color={theme.colors.mineShaft} mx={theme.spacing.xxxs} mb={theme.spacing.xs}>
                        <Text fontSize="1.2em">{newT('submission.importList.stepsHeader').toUpperCase()}</Text>
                        {ActionType.WAITLIST === actionType ? (
                            <Text style={{ lineHeight: '28px' }}>
                                <div style={{ paddingInlineStart: '20px' }}>
                                    <div>{newT('submission.importList.stepOne')}</div>
                                    <div>{newT('submission.importList.stepTwoWaitlist')}</div>
                                    <div>{newT('submission.importList.stepThreeWaitlist')}</div>
                                    <div>{newT('submission.importList.stepFourWaitlist')}</div>
                                </div>
                            </Text>
                        ) : (
                            <Text style={{ lineHeight: '28px' }}>
                                <div style={{ paddingInlineStart: '20px' }}>
                                    <div>{newT('submission.importList.stepOne')}</div>
                                    <div>{newT('submission.importList.stepTwoApprovalList')}</div>
                                    <div>{newT('submission.importList.stepThreeApprovalList')}</div>
                                </div>
                            </Text>
                        )}
                        {ActionType.APPROVE === actionType && interestRegistrationRemainingSlots !== undefined ? (
                            <Box textAlign="center" my={theme.spacing.xxxs}>
                                <Text fontSize="1.3em">
                                    {newT('submission.importList.numberOfPartiposterSelectedHeader', {
                                        count: remainSlotsInfo.remainSlotsError
                                            ? 0
                                            : remainSlotsInfo.listUserTotalNum > interestRegistrationRemainingSlots
                                              ? interestRegistrationRemainingSlots
                                              : remainSlotsInfo.listUserTotalNum,
                                    })}
                                </Text>
                                <Text fontSize="0.8em">
                                    {newT('submission.importList.remainingSlotsSubtext', {
                                        count: interestRegistrationRemainingSlots,
                                    })}
                                </Text>
                            </Box>
                        ) : null}
                    </Box>
                </Box>
            </ListApprovePopUp>
        </>
    )
}

export default RegistrationsListApproval
